import React, { useState } from 'react';
import {
    Button,
    FormControl,
    FormLabel,
    Icon,
    IconButton,
    Input,
    Text,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Stack,
    Tooltip,
    Box,
    Checkbox,
    CheckboxGroup,
    Switch,
} from '@chakra-ui/react';
import { VscEdit } from 'react-icons/vsc';
import { useDispatch } from 'react-redux';
import { updateRol, getRoles } from '../../features/rolSlice';

export const ModalEditarRol = ({ row, page, perPage }) => {
    const dispatch = useDispatch();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const initialValues = {
        key: '',
        descripcion: '',
        estado: true,
        permisos: []
    };

    const [indice, setIndice] = useState(initialValues);

    const handleModalOpen = (data) => {
        setIsModalOpen(true);

        // Asegura que el campo 'permisos' sea un array de strings
        const permisos = data.permisos?.map(p => typeof p === 'object' ? p.key : p) || [];

        setIndice({
            id: data.id, // ✅ <-- AÑADE EL ID AQUÍ
            key: data.key || '',
            descripcion: data.descripcion || '',
            estado: data.estado ?? true,
            permisos: permisos
        });
    };

    const handleModalClose = () => {
        setIsModalOpen(false);
        setIndice(initialValues); // Limpia el formulario
    };

    const handleUpdate = (indice) => {
        dispatch(updateRol(indice)).then(() => {
            dispatch(getRoles({ page, perPage }));
            handleModalClose();
        });
    };

    const handlePermisosChange = (newPermisos) => {
        setIndice({ ...indice, permisos: newPermisos });
    };

    const modulos = [
        {
            titulo: "Configuraciones Básicas",
            permisos: [
                { label: "Ver Ciudad", value: "ver_modulo_ciudad" },
                { label: "Ver País", value: "ver_modulo_pais" },
                { label: "Ver Usuario", value: "ver_modulo_usuario" },
                { label: "Ver Persona", value: "ver_modulo_persona" },
                { label: "Ver Servicio", value: "ver_modulo_servicio" },
                { label: "Ver Roles", value: "ver_modulo_rol" },
                { label: "Ver Permisos", value: "ver_modulo_permiso" },
                { label: "Ver Configuraciones", value: "ver_modulo_configuraciones" },
                { label: "Ver Cliente", value: "ver_modulo_cliente" },
            ]
        },
        {
            titulo: "Módulo de Factura",
            permisos: [
                { label: "Ver Factura", value: "ver_modulo_factura" },
                { label: "Crear", value: "crear_factura" },
                { label: "Eliminar", value: "eliminar_factura" },
                { label: "Editar", value: "editar_factura" },
                { label: "Detalles", value: "detalle_factura" },
                { label: "Reporte PDF", value: "generar_factura_pdf" },
            ]
        }
    ];

    const togglePermisosModulo = (moduloPermisos, checked) => {
        const current = new Set(indice.permisos);
        moduloPermisos.forEach(p => {
            if (checked) {
                current.add(p.value);
            } else {
                current.delete(p.value);
            }
        });
        setIndice({ ...indice, permisos: Array.from(current) });
    };

    const isFormValid = indice.key.trim() !== '' && indice.descripcion.trim() !== '';

    return (
        <>
            <Tooltip hasArrow label="Editar" placement="auto">
                <IconButton
                    colorScheme="blackAlpha"
                    _dark={{ color: "white", _hover: { bg: "whiteAlpha.200" } }}
                    aria-label="Editar"
                    icon={<Icon as={VscEdit} fontSize="2xl" />}
                    variant="ghost"
                    onClick={() => handleModalOpen(row)}
                    ml={2}
                />
            </Tooltip>

            <Modal isOpen={isModalOpen} onClose={handleModalClose} size="5xl" isCentered>
                <ModalOverlay
                    bg="rgba(11,15,25, 0.8)"
                    backdropFilter="auto"
                    backdropBlur="2px"
                />
                <ModalContent _dark={{ bg: "primary.1000" }} borderRadius="2xl">
                    <ModalHeader textAlign="center">ACTUALIZAR ROL</ModalHeader>
                    <ModalCloseButton />

                    <ModalBody>
                        <Stack spacing={4} p={4}>
                            <Stack spacing={4} direction={{ base: "column", lg: "row" }} justifyContent="space-between" p={4}>
                                <Text fontWeight="semibold">ESTADO</Text>
                                <Switch
                                    onChange={(e) => setIndice({ ...indice, estado: e.target.checked })}
                                    isChecked={indice.estado}
                                    colorScheme="purple"
                                    size="lg"
                                />
                            </Stack>

                            <Stack direction={{ base: "column", lg: "row" }} spacing={4}>
                                <FormControl isRequired>
                                    <FormLabel fontWeight="semibold">NOMBRE</FormLabel>
                                    <Input
                                        placeholder="Ingrese el nombre del rol"
                                        type="text"
                                        value={indice.key}
                                        onChange={(e) => setIndice({ ...indice, key: e.target.value })}
                                    />
                                </FormControl>

                                <FormControl isRequired>
                                    <FormLabel fontWeight="semibold">DESCRIPCIÓN</FormLabel>
                                    <Input
                                        placeholder="Ingrese la descripción del rol"
                                        type="text"
                                        value={indice.descripcion}
                                        onChange={(e) => setIndice({ ...indice, descripcion: e.target.value })}
                                    />
                                </FormControl>
                            </Stack>

                            {modulos.map((modulo, idx) => {
                                const todosSeleccionados = modulo.permisos.every(p => indice.permisos.includes(p.value));
                                return (
                                    <Box
                                        key={idx}
                                        borderWidth="1px"
                                        borderRadius="xl"
                                        p={4}
                                        mt={4}
                                        _dark={{ borderColor: "gray.700", bg: "gray.900" }}
                                        bg="gray.50"
                                    >
                                        <Stack
                                            direction="row"
                                            justify="space-between"
                                            align="center"
                                            mb={2}
                                            flexWrap="wrap"
                                        >
                                            <Text fontSize="lg" fontWeight="bold" color="blue.600">
                                                {modulo.titulo}
                                            </Text>

                                            <Checkbox
                                                isChecked={todosSeleccionados}
                                                onChange={(e) => togglePermisosModulo(modulo.permisos, e.target.checked)}
                                                colorScheme="blue"
                                            >
                                                Marcar todas
                                            </Checkbox>
                                        </Stack>

                                        <CheckboxGroup
                                            value={indice.permisos}
                                            onChange={handlePermisosChange}
                                            colorScheme="blue"
                                        >
                                            <Stack spacing={2} direction="row" flexWrap="wrap">
                                                {modulo.permisos.map((permiso, i) => (
                                                    <Checkbox key={i} value={permiso.value}>
                                                        {permiso.label}
                                                    </Checkbox>
                                                ))}
                                            </Stack>
                                        </CheckboxGroup>
                                    </Box>
                                );
                            })}
                        </Stack>
                    </ModalBody>

                    <ModalFooter>
                        <Button
                            colorScheme="red"
                            _dark={{ bg: "red.500", color: "white", _hover: { bg: "red.600" } }}
                            size="lg"
                            mr={3}
                            onClick={handleModalClose}
                            borderRadius="xl"
                        >
                            CANCELAR
                        </Button>
                        <Button
                            colorScheme="green"
                            _dark={{ bg: "green.600", color: "white", _hover: { bg: "green.800" } }}
                            size="lg"
                            mr={3}
                            onClick={() => handleUpdate(indice)}
                            borderRadius="xl"
                            isDisabled={!isFormValid}
                        >
                            ACTUALIZAR
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    );
};
